import React from 'react';

import { InputReg } from '@interlayer/js/app/components/main/Registration/components/common/InputReg';

import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const ZipField: React.FC = () => {
    return (
        <InputReg name={VALIDATION_FIELDS.zip} />
    );
};
